import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

export enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
export type NewGlossary = {
  glossaryName: string;
  glossaryType: string;
  comment: string;
  description: string;
  status: Status;
};

export type Glossary = {
  glossaryId: string;
  glossaryName: string;
  glossaryType: string;
  comment: string;
  description: string;
  status: Status;
};

@Injectable({
  providedIn: "root",
})
export class GlossaryService {
  private API_URL: string;
  private token: any;
  private idToken: any;

  constructor(private http: HttpClient, @Inject("API_URL") apiUrl: string) {
    this.API_URL = apiUrl;
    this.token = localStorage.getItem('token');
    this.idToken = localStorage.getItem('id_token');
  }

  getGlossary(): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `${this.token}`).set('id_token', `${this.idToken}`);
    return this.http.get<any>(`${this.API_URL}/admin/glossary`, { headers });
  }

  createGlossary(body: NewGlossary): Observable<Glossary> {
    const headers = new HttpHeaders().set('Authorization', `${this.token}`).set('id_token', `${this.idToken}`);
    return this.http.post<Glossary>(`${this.API_URL}/admin/glossary`, body, { headers });
  }

  updateGlossary(body: Glossary): Observable<Glossary> {
    const headers = new HttpHeaders().set('Authorization', `${this.token}`).set('id_token', `${this.idToken}`);
    return this.http.post<Glossary>(`${this.API_URL}/admin/glossary`, body, { headers });
  }
}
